import React, {} from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import ARButton from "./components/ar3d/ar/ARButton";
//import ARButtonWebXR from "./components/ar3d/ARButtonWebXR";
import {DEVICE_TYPE, getDeviceType} from "./helpers/sqftMobileHelper";
import ARButtonGoogleWebXR from "./components/ar3d/ar/ARButtonGoogleWebXR";

const SquareFootageToolAR = (props) => {
  const {match} = props;
  const file = match.params ? match.params.file : null;
  //set glb file to display it in AR
  //void file;
  //const url = 'https://d1mb1i73swc8dz.cloudfront.net/ar-composer/All-Bottom Cabinet-Light Italian Walnut-Bryant-30-34.5-SB.glb';
  const url = 'https://s3.amazonaws.com/qc-3dfiles/composed/' + file + '.glb'

  const getArButton = () => {
    switch (getDeviceType()) {
      case DEVICE_TYPE.Android:
        return <ARButtonGoogleWebXR url={url} />
      case DEVICE_TYPE.iOS:
      case DEVICE_TYPE.unknown:
        return <ARButton url={url} />
    }
  }

  return (
    <div className="sqft">
      <div className="ar-page">
        {/*<img src={qrImage} alt='' />*/}
        {getArButton()}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    visualizersLoaded: store.serverState.visualizersLoaded,
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(SquareFootageToolAR)
  )
);
